import { useUk } from '../../../hooks'
import { getQaSelector, isDefaultLogoSrc } from '../../../utils/common'
import { FormHeader } from '../../Form'
import { Link } from '../../Link'
import Text from '../../Text'

import * as styles from './AuthHeader.module.css'

import IdwellLogo from '../../../icons/logo-idwell.svg'

function AuthHeader({ description, link, notifications }) {
  const { logo: ukLogo } = useUk()

  const logo = ukLogo?.origin

  return (
    <div className={styles.headerContainer}>
      <div className={styles.header}>
        {/* TODO replace default logo on backend */}
        {isDefaultLogoSrc(logo) ? (
          <IdwellLogo className={styles.idwellLogo} />
        ) : (
          <img alt='' className={styles.logo} src={logo} />
        )}
        {link && description ? (
          <div className={styles.box}>
            <Text className={styles.text}>{description}</Text>
            <Link
              {...(link.qaName ? getQaSelector({ value: link.qaName }) : null)}
              className={styles.link}
              to={link.to}
            >
              {link.text}
            </Link>
          </div>
        ) : null}
      </div>
      <FormHeader notifications={notifications} />
    </div>
  )
}

export default AuthHeader
